/**
 * Digital Advisor Solutions Service API 1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { Observable } from 'rxjs';
import { AjaxRequest } from 'rxjs/observable/dom/AjaxObservable';
//@ts-ignore
// import * as models from '../model/models';
import { RemoteData } from '@assetmark/ui-kit/dist/utils/remote-data.utils';
import { ObjectUtils } from '@assetmark/ui-kit/dist/utils/object.utils';


import { ProblemDetails } from '../model/problemDetails';
import { StampRequest } from '../model/stampRequest';

import {
	DasApiClient as ApiClient
	
} from '../../../apis/api.client';

// import isNotNullable = ObjectUtils.isNotNullable;

type TQueryParam = {
	key: string,
	value: string | string[] | boolean | number | Date | undefined,
}


// eslint-disable-next-line @typescript-eslint/no-namespace 
export namespace ReportService {
	/**
	* 
		* @summary Deleting Existing Pdf and save the new one.
	* @param leadId - The Lead identifier. 75299dbc-4df6-4bbb-a57a-dc0d74a89b6e
	* @param body - The Document Request.
	* @param agentId - The agent identifier. AG1634
	*/
	export function apiDasV1ReportSaveleadpdfLeadIdPost(leadId: string, body?: Array<StampRequest>, agentId?: string, customHeaders: Object = {}): Observable<RemoteData<{}>> {
		const path = `/api/das/v1/report/saveleadpdf/${encodeURIComponent(String(leadId))}`.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId));
		const allQueryParams: TQueryParam[] = [
				{
					key: 'agentId',
					value: agentId
				},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		const apiUrl = queryParams === '' ? path : path.concat(`?${queryParams}`);
		let headers = customHeaders;
		const ajaxRequest: AjaxRequest = {
			url: apiUrl,
			method: 'post',
			body: body,
			headers: { ...headers }
		};
		return ApiClient.request(ajaxRequest);
	}

	export function getUrlForapiDasV1ReportSaveleadpdfLeadIdPost(leadId: string, body?: Array<StampRequest>, agentId?: string, ): string {
		const path = '/api/das/v1/report/saveleadpdf/${encodeURIComponent(String(leadId))}'.replace(/^\//, '').replace('{' + 'leadId' + '}', String(leadId));
		const allQueryParams: TQueryParam[] = [
			{
			key: 'agentId',
			value: agentId
			},
		];
		const queryParams = allQueryParams.filter(param => ObjectUtils.isNotNullable(param.value)).map(param => `${param.key}=${param.value}`).join('&');
		return queryParams === '' ? path : path.concat(`?${queryParams}`);
	}
}
